import type { RouteRecordRaw } from "vue-router";

const DEFAULT_META = {
  layout: "default",
  requiresAuth: true,
  checkPrivileges: () => {
    return true;
  },
};

function addDefaultMeta(routes: RouteRecordRaw[]): RouteRecordRaw[] {
  return routes.map((route) => {
    if (!route.meta) {
      route.meta = {};
    }

    if (route.meta.layout === undefined) {
      route.meta.layout = DEFAULT_META.layout;
    }

    if (route.meta.requiresAuth === undefined) {
      route.meta.requiresAuth = DEFAULT_META.requiresAuth;
    }

    if (route.children) {
      route.children = addDefaultMeta(route.children);
    }

    if (route.meta.checkPrivileges === undefined) {
      route.meta.checkPrivileges = DEFAULT_META.checkPrivileges;
    }

    return route;
  });
}

export function isSafeInternalReturnPath(raw: string): boolean {
  if (!raw.startsWith("/") || raw.startsWith("//")) return false;

  const pathOnly = raw.split("?")[0]?.split("#")[0] ?? "";
  return pathOnly.startsWith("/") && !pathOnly.startsWith("//");
}

export { addDefaultMeta, DEFAULT_META };
